import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {Power1, Power3, TweenLite} from "gsap";

import ReactDOM from 'react-dom'

let leaveWrapperHeight = 0
let enterWrapperHeight = 0

class StepWrapper extends Component {

    static propTypes = {
        blockMouse: PropTypes.bool
    }

    static defaultProps = {
        blockMouse: false
    }

    static get SCROLL_DURATION() {
        return Math.min(Math.max(0.35, (window.scrollY - 140) / 700), 0.75)
    }

    constructor(props) {
        super(props)
        this.state = {
            hidden: true,
            animating: false
        }
        this.stepChildRef = React.createRef();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.hidden !== this.state.hidden) {
            return true
        }

        if (nextState.animating !== this.state.animating) {
            return true
        }

        if (nextProps.blockMouse !== this.props.blockMouse) {
            return true
        }

        if (this.props.children.props !== nextProps.children.props) {
            return true
        }

        return false
    }

    componentWillAppear(callback) {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.killTweensOf(dom)
        TweenLite.fromTo(dom, 0.95,
            {
                y: 20,
                opacity: 0
            },
            {
                ease: Power3.easeOut,
                opacity: 1,
                y: 0,
                onComplete: () => {
                    this.setState({hidden: false, animating: false});
                    TweenLite.set(dom, {clearProps: "all"});
                    callback()
                }
            }
        )

        enterWrapperHeight = dom.offsetHeight
        leaveWrapperHeight = dom.offsetHeight

        const stepDisplay = document.getElementsByClassName('step-display')[0]
        stepDisplay.classList.add("step-display--animating")


        TweenLite.to(stepDisplay, 0.95, {
            ease: Power3.easeOut, height: enterWrapperHeight, onComplete: () => {
                TweenLite.set(stepDisplay, {clearProps: "all"});
                stepDisplay.classList.remove("step-display--animating")
            }
        })
    }

    isScrollUpNeeded = () => {
        return window.scrollY > 140
    }

    componentWillEnter(callback) {

        this.setState({animating: true, hidden: true})

        // time out to wait for leaveWrapperHeight to be set
        setTimeout(() => {

            const scrollUpNeeded = this.isScrollUpNeeded()

            const dom = ReactDOM.findDOMNode(this)
            TweenLite.killTweensOf(dom)
            TweenLite.set(dom, {clearProps: "all"});
            TweenLite.fromTo(dom, 0.4, {y: 15, opacity: 0}, {
                delay: 0.3 + (scrollUpNeeded ? StepWrapper.SCROLL_DURATION : 0), ease: Power3.easeOut, opacity: 1, y: 0, onComplete: () => {
                    callback()
                }
            })

            enterWrapperHeight = dom.offsetHeight

            const stepDisplay = document.getElementsByClassName('step-display')[0]
            stepDisplay.classList.add("step-display--animating")

            TweenLite.killTweensOf(stepDisplay)
            TweenLite.fromTo(stepDisplay, 1, {height: leaveWrapperHeight}, {
                delay: 0.3 + (scrollUpNeeded ? StepWrapper.SCROLL_DURATION : 0), ease: Power3.easeOut, height: enterWrapperHeight, onComplete: () => {
                    TweenLite.set(stepDisplay, {clearProps: "all"});
                    stepDisplay.classList.remove("step-display--animating")
                    TweenLite.set(dom, {clearProps: "all"});
                    this.setState({hidden: false, animating: false})
                }
            })
        }, 10)
    }

    componentWillLeave(callback) {

        const scrollUpNeeded = this.isScrollUpNeeded()

        this.setState({animating: true})

        const dom = ReactDOM.findDOMNode(this)
        TweenLite.killTweensOf(dom)
        TweenLite.set(dom, {clearProps: "all"});
        TweenLite.to(dom, 0.25, {
            delay: (scrollUpNeeded ? StepWrapper.SCROLL_DURATION : 0), ease: Power3.easeOut, opacity: 0, onComplete: () => {
                this.setState({animating: false})
                callback()
            }
        })


        TweenLite.killTweensOf(window)

        TweenLite.to(window, StepWrapper.SCROLL_DURATION, {scrollTo: {y: 0}, ease: Power1.easeInOut})

        // inject leave method to steps
        try {
            this.stepChildRef.current.getWrappedInstance().componentWillLeave()
        } catch (error) {
        }

        leaveWrapperHeight = dom.offsetHeight

    }

    componentWillUnmount() {

        const dom = ReactDOM.findDOMNode(this)
        TweenLite.killTweensOf(dom)

    }

    render() {

        const childrenWithInjectedProp = React.Children.map(this.props.children,
            (child) => React.cloneElement(child, {
                key: child.key,
                ref: this.stepChildRef
            })
        )

        return (
            <div className={"step-wrapper " + (this.state.animating ? 'step-wrapper--animating ' : '') + (this.state && this.state.hidden ? 'step-wrapper--hidden' : '')}>
                {(this.props.blockMouse || this.state.animating) ? <div className="mouse-block"></div> : null}
                {childrenWithInjectedProp}
            </div>
        )

    }

}

export default StepWrapper


/** WEBPACK FOOTER **
 ** ./src/components/StepWrapper.js
 **/